import { ChartData } from "../../Editor/Displays/Chart";


export function renderPieChart(data:ChartData, chartData){
    chartData.series = data.values[0].map(Number);
    chartData.labels = data.labels;
    delete chartData.xaxis;
    // chartData.dataLabels = 
    chartData.legend = {
        "show": true,
        "showForSingleSeries": false,
        "showForNullSeries": true,
        "showForZeroSeries": true,
        "floating": false,
        "position": "right",
        "horizontalAlign": "center",
        "inverseOrder": false,
        "fontSize": "12px",
        "fontWeight": 400,
        "offsetX": 0,
        "offsetY": 0,
        "markers": {
            "width": 12,
            "height": 12,
            "strokeWidth": 0,
            "strokeColor": "#fff",
            "radius": 12,
            "offsetX": 0,
            "offsetY": 0
        },
        "itemMargin": {
            "horizontal": 5,
            "vertical": 2
        },
        "onItemClick": {
            "toggleDataSeries": false
        },
        "onItemHover": {
            "highlightDataSeries": true
        },
        "enabled": true,
        "textAnchor": "middle",
        "distributed": false,
        "style": {
            "fontSize": "12px",
            "fontWeight": 600,
            "colors": [
                "#fff"
            ]
        },
        "background": {
            "enabled": false,
            "foreColor": "#fff",
            "borderRadius": 2,
            "padding": 4,
            "opacity": 0.9,
            "borderWidth": 1,
            "borderColor": "#fff",
            "dropShadow": {
                "enabled": false,
                "top": 1,
                "left": 1,
                "blur": 1,
                "color": "#000",
                "opacity": 0.45
            }
        },
        "dropShadow": {
            "enabled": true,
            "top": 1,
            "left": 1,
            "blur": 1,
            "color": "#000",
            "opacity": 0.45
        }
    }
    chartData.dataLabels = {
        "enabled": true,
        "textAnchor": "middle",
        "distributed": false,
        "offsetX": 0,
        "offsetY": 0,
        "style": {
            "fontSize": "12px",
            "fontWeight": 600,
            "colors": [
                "#fff"
            ]
        },
        "formatter": function(val){
            return Math.round(val) + " %"
        },
        "background": {
            "enabled": false,
            "foreColor": "#fff",
            "borderRadius": 2,
            "padding": 4,
            "opacity": 0.9,
            "borderWidth": 1,
            "borderColor": "#fff",
            "dropShadow": {
                "enabled": false,
                "top": 1,
                "left": 1,
                "blur": 1,
                "color": "#000",
                "opacity": 0.45
            }
        },
        "dropShadow": {
            "enabled": true,
            "top": 1,
            "left": 1,
            "blur": 1,
            "color": "#000",
            "opacity": 0.45
        }
    }
    chartData.tooltip = {
        "enabled": true,
        "shared": true,
        "followCursor": false,
        "intersect": false,
        "inverseOrder": false,
        "fillSeriesColor": true,
        "theme": "dark",
        "style": {
            "fontSize": "12px"
        },
        "onDatasetHover": {
            "highlightDataSeries": false
        },
        "formatter": function(val){
            return Math.round(val) + " %"
        },
        "x": {
            "show": true,
            "format": "dd MMM"
        },
        "y": {
            "title": {}
        },
        "z": {
            "title": "Size: "
        },
        "marker": {
            "show": true
        },
        "items": {
            "display": "flex"
        },
        "fixed": {
            "enabled": false,
            "position": "topRight",
            "offsetX": 0,
            "offsetY": 0
        }
    }
    // delete chartData.xaxis;
    
    
    return chartData;
}